var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c(
        "PageHeader",
        {
          staticClass: "page-header-overdue-invoice",
          attrs: { pageTitle: "Faturas Atrasadas" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", gap: "0.5rem" } },
            [
              _c("GenericSearchInput", {
                model: {
                  value: _vm.search.field,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "field", $$v)
                  },
                  expression: "search.field"
                }
              }),
              _vm._v(" "),
              _c("SelectMonth", {
                model: {
                  value: _vm.search.month,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "month", $$v)
                  },
                  expression: "search.month"
                }
              }),
              _vm._v(" "),
              _c("SelectYear", {
                model: {
                  value: _vm.search.year,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "year", $$v)
                  },
                  expression: "search.year"
                }
              }),
              _vm._v(" "),
              _c("SelectAccountManager", {
                model: {
                  value: _vm.search.accountManagerId,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "accountManagerId", $$v)
                  },
                  expression: "search.accountManagerId"
                }
              }),
              _vm._v(" "),
              _vm.overdueInvoiceStatusList.length
                ? _c("SelectPromoter", {
                    attrs: { traderList: _vm.traderList },
                    model: {
                      value: _vm.search.trader,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "trader", $$v)
                      },
                      expression: "search.trader"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("SelectInstallationStatus", {
                model: {
                  value: _vm.search.installationStatus,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "installationStatus", $$v)
                  },
                  expression: "search.installationStatus"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("b-skeleton-table", {
            staticStyle: { "margin-top": "2rem" },
            attrs: {
              animation: "wave",
              rows: 5,
              columns: 15,
              "table-props": { bordered: true, striped: true }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.overdueInvoiceStatusList.length && !_vm.isLoading
        ? _c(
            "section",
            { staticStyle: { "margin-bottom": "2rem" } },
            [
              _c("OverdueInvoiceSummaryTable", {
                attrs: {
                  overdueInvoiceStatusList: _vm.overdueInvoiceStatusList
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.overdueInvoiceStatusList, function(invoiceStatus, index) {
        return !_vm.isLoading
          ? _c(
              "section",
              { key: `${invoiceStatus.name}_${index}` },
              [
                invoiceStatus.list.length
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "2rem",
                          "margin-top": "1rem"
                        }
                      },
                      [
                        _c("h3", [_vm._v(_vm._s(invoiceStatus.name))]),
                        _vm._v(" "),
                        _c(
                          "vue-json-to-csv",
                          {
                            attrs: {
                              "json-data": invoiceStatus.csvList,
                              separator: ";",
                              "csv-title": `${invoiceStatus.name}_CSV`
                            }
                          },
                          [
                            _c(
                              "BaseButtonComponent",
                              {
                                attrs: { block: "", variant: "primary-action" }
                              },
                              [_vm._v("\n          CSV\n        ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("OverdueInvoiceTable", {
                  attrs: { list: invoiceStatus.list, isLoading: _vm.isLoading },
                  on: {
                    changeInvoiceToAnotherJudicialTable:
                      _vm.changeInvoiceToAnotherJudicialTable,
                    sendInvoiceToSmallClaims: _vm.sendInvoiceToSmallClaims,
                    sendInvoiceToSerasa: _vm.sendInvoiceToSerasa,
                    sendInvoiceToProtest: _vm.sendInvoiceToProtest
                  }
                })
              ],
              1
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }